import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    fontSize: '1.4rem',
    textAlign: 'center',
  },
}))
